import React from 'react';

export function useCastedRef<T>(ref?: any): React.MutableRefObject<T> {
    return typeof window !== `undefined` ? (React.useRef<T>(ref) as React.MutableRefObject<T>) : null;
}
